import {
	Logger,
} from '@stonal-tech/lib-logging-ts';

export const logger = new Logger({
	context: {
		service: 'lib-front-tracking-ts',
	},
});
